module.exports = __webpack_public_path__ + "static/media/reports-end-of-day.a4e656c5.svg";